// @flow
import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import Switch from '@material-ui/core/Switch'
import AnimationControls from './animation_controls'
import stylesFicus from '../styles'
import * as colors from '../styles/colors'
import type { SelectFrameworkBarType } from '../reducers/select_framework_bar'
import type { AnalyzeFrameworkBarType } from '../reducers/analyze_framework_bar'
import ButtonGroup from './buttongroup'

export type Props = {
    addBookmark: Function,
    config: AnalyzeFrameworkBarType,
    ficus: SelectFrameworkBarType,
    removeMapLocations: Function,
    setAnalyzeMode: Function,
    setConfig: Function,
    theme: stylesFicus,
}

export type State = {
    ispeed: number,
    mapLabels: boolean,
    message: string,
}

class TransimControls extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = { ispeed: 1, currentInterval: 0, mapLabels: true, message: '' }
    }

    modeText: {} = {
        _allRealizations: 'Realizations',
        _quickOverview: 'Quartiles',
        _ranges: 'Others',
    }

    addMessage(message: string) {
        this.setState({ ...this.state, message })
    }

    removeMessage() {
        this.setState({ ...this.state, message: '' })
    }

    render() {
        const containerStyle = { padding: '6px 10px' }

        let buttons = []
        if (this.props.config.modes) {
            buttons = this.props.config.modes.map(m => ({ value: m, content: this.modeText[m], title: m }))
        }

        const changeAnalyzeMode = (v) => {
            this.props.setConfig({ started: false })
            this.props.setAnalyzeMode(v)
        }

        return (
            <React.Fragment>
                <div className={this.props.theme.top}>
                    <div>
                        <div className={this.props.theme.toolbuttonPanel}>
                            <button
                                className={this.props.theme.toolbutton}
                                onClick={() => this.props.removeMapLocations()}
                                title="Remove all map popups"
                            >
                                <i className={'fa fa-trash'} />
                            </button>
                            <button
                                className={this.props.theme.toolbutton}
                                onClick={() => {
                                    this.props.addBookmark('bookmarksLocal', this.props.ficus.ficusNode)
                                    this.addMessage('Bookmark added')
                                }}
                                title="Add to Bookmarks"
                            >
                                <i className={'fa fa-bookmark'} />
                            </button>
                            <div className={this.props.theme.buttonGroup}>
                                <ButtonGroup
                                    allowEmpty={false}
                                    buttons={buttons}
                                    enabled={!this.props.ficus.fetchingFicusData}
                                    onChange={v => changeAnalyzeMode(v)}
                                    styles={{ button: stylesControls.button }}
                                    value={this.props.config.mode}
                                />
                            </div>
                        </div>

                        <AnimationControls config={this.props.config} ficus={this.props.ficus} setConfig={this.props.setConfig} />

                        <div style={containerStyle}>
                            <span>Show Labels </span>
                            <div style={{ display: 'inline-block', width: '110px', marginLeft: '20px', marginBottom: '10px' }}>
                                <Switch
                                    checked={this.props.config.showLabels}
                                    color="secondary"
                                    onChange={() => this.props.setConfig({ showLabels: !this.props.config.showLabels })}
                                />
                            </div>
                            <span
                                className={`fa fa-question-circle-o ${this.props.theme.helpIcon}`}
                                tabIndex={-1}
                                onClick={() => this.setState({ ...this.state, mapLabels: !this.state.mapLabels })}
                                role="button"
                            />
                            {this.state.mapLabels && (
                                <div className={this.props.theme.help}>
                                    Show attribute values as feature labels in the map.
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={4000}
                    message={this.state.message}
                    open={this.state.message !== ''}
                    onClose={() => this.removeMessage()}
                    ContentProps={{ style: { backgroundColor: colors.secondaryOne } }}
                />
            </React.Fragment>
        )
    }
}

export default TransimControls
